import script from "./sw-item-parts-switch.vue?vue&type=script&setup=true&lang=js"
export * from "./sw-item-parts-switch.vue?vue&type=script&setup=true&lang=js"

import "./sw-item-parts-switch.vue?vue&type=style&index=0&id=54a7d77c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54a7d77c"]])

export default __exports__